import React, { memo } from 'react'

function LoadingCard() {
  return <div className="three-d-model-picker__card three-d-model-picker__card--loading shimmer" />
}

export default memo(LoadingCard)
